import React from 'react'
import styled from 'styled-components'

import useKeyboardHandle from '../common/hooks/useKeyboardHandle'
import useText from '../common/hooks/useText'

import BootstrapModalLayout from './BootstrapModalLayout'

const SDescription = styled.p`
    font-family: ${({ theme }) => theme.font.name};
    font-size: 1em;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5em;
    letter-spacing: 0em;
`

const formId = 'confirmation-form'

export default function ConfirmationModal({
    title,
    onClose,
    size = 'sm',
    onConfirm,
    message,
    confirmButtonText,
    cancelButtonText,
}: Props): React.ReactElement {
    const text = useText()
    useKeyboardHandle({ onEscapePress: onClose, onEnterPress: onConfirm })

    return (
        <BootstrapModalLayout
            title={title}
            size={size}
            actions={[
                {
                    label: cancelButtonText || text('btnCancel'),
                    callback: onClose,
                    btn: 'btn-secondary',
                    type: 'button',
                    form: formId,
                    dataTestId: 'cancel',
                },
                {
                    label: confirmButtonText || text('btnConfirm'),
                    type: 'submit',
                    form: formId,
                    dataTestId: 'confirm',
                },
            ]}
        >
            <form
                id={formId}
                onSubmit={(event) => {
                    event.preventDefault()
                    onConfirm()
                }}
                data-testid="modal-form"
            >
                <SDescription>{message}</SDescription>
            </form>
        </BootstrapModalLayout>
    )
}

export type Props = {
    title?: string | React.ReactNode
    size?: number | 'sm' | 'md' | 'lg' | undefined
    onClose: () => void
    onConfirm: () => void
    message: React.ReactNode
    cancelButtonText?: string
    confirmButtonText?: string
}
